import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';
import TranslationContext from './TranslationContext';
const withTranslations = (Component) => {
    const Hoc = props => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { locales, ...rest } = React.useContext(TranslationContext);
        return <Component {...props} {...rest}/>;
    };
    Hoc.displayName = `withTranslations(${Component.displayName || Component.name})`;
    return hoistNonReactStatics(Hoc, Component);
};
withTranslations.props = {
    t: PropTypes.func,
};
export default withTranslations;
